export const modal = {
  small: {
    width: "472px",
    height: "296px"
  },
  medium: {
    width: "680px",
    height: "456px"
  },
  large: {
    width: "888px",
    height: "624px"
  },
  full: {
    width: "100%",
    height: "100vh"
  }
};